import { ImportInventaireVergersComponent } from './import-inventaire-vergers.component';

export const IMPORT_INVENTAIRE_VERGERS_ROUTES = [
    {
        path: '',
        component: ImportInventaireVergersComponent,
        data: {
            role: 'ORGANISME || GP',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.import-inventaire-vergers',
                icon: 'key'
            }
        }
    }
];
